<template>
  <div class="slide">
    <div class="left-box">
      <div class="photo-box">
        <img :src="data.profilePicture.url">
      </div>
      <div class="name-box">
        {{ `~ ${data.name}` }}
      </div>
      <div class="text-box">
        {{ data.opinion }}
      </div>
    </div>
    <div class="right-box">
      <img :src="data.image.url">
    </div>
  </div>
</template>

<script>
export default {
  name: 'OpinionSlide',
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
.slide {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 850px) {
    flex-direction: column;
    padding-bottom: 2rem;
  }
}

.left-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 50rem;

  @media (max-width: 850px) {
    max-width: unset;
  }
  @media (max-width: 550px) {
    padding-top: 1rem;
  }
  @media (max-width: 500px) {
    padding-top: 2rem;
  }

  .photo-box {
    img {
      width: 8rem;
      border-radius: 100%;
      border: 2px solid #F4F4F4;

      @media (max-width: 400px) {
        width: 7rem;
      }
    }
  }

  .name-box {
    margin-top: 2rem;
    color: #F4F4F4;
    font-size: 1.2rem;
    font-style: italic;
    font-weight: 300;

    @media (max-width: 400px) {
      font-size: 1.1rem;
    }
  }

  .text-box {
    margin-top: 2rem;
    color: #F4F4F4;
    opacity: 0.9;
    font-size: 1.2rem;
    width: 30rem;
    text-align: justify;
    line-height: 1.7rem;
    @media (max-width: 1100px) {
      width: 25rem;
    }
    @media (max-width: 900px) {
      width: 22rem;
    }
    @media (max-width: 850px) {
      width: 31rem;
    }
    @media (max-width: 600px) {
      width: 85%;
    }
    @media (max-width: 400px) {
      font-size: 1.1rem;
    }
  }
}

.right-box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 50rem;

  @media (max-width: 850px) {
    max-width: unset;
  }

  @media (max-width: 400px) {
    flex: unset;
    padding-top: 1rem;
    padding-bottom: 2rem;
  }

  img {
    width: 35rem;
    border-radius: 0.3rem;
    @media (max-width: 1200px) {
      width: 30rem;
    }
    @media (max-width: 1000px) {
      width: 25rem;
    }
    @media (max-width: 850px) {
      width: 31rem;
    }
    @media (max-width: 600px) {
      width: 85%;
    }
  }
}
</style>